<template>
    <div class="uploadFileDialog">
        <el-dialog title="上传资料" :visible.sync="dialogVisible" width="630px" :close-on-click-modal="false">
            <el-form :model="item" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
                <el-form-item label="资料名称">
                    <el-input placeholder="请输入资料名称，不输则默认为文件名" v-model="item.filename"></el-input>
                </el-form-item>
                <el-form-item label="资料" prop="file.fname">
                    <uploadFile :uploadType="uploadType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                    <div>{{item.file.fname}}</div>
                    <p class="dataTips">建议上传ppt、pdf格式， 文件大小不能超过1G。</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submit">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import UploadFile from 'base/upload/uploadFileResume'

export default {
    name: 'uploadFileDialog',
    data() {
        return {
            dialogVisible: false,
            uploadType: {
                catecode: '94',
                datatype: 'FILE'
            },
            fileRule: {
                btnName: '选择文件',
                showFileFist: true,
                multiple: true,
                cls: '',
                accept: '',
                size: 2 * 1024,
                width: '',
                height: ''
            },
            item: {
                filename: '',
                file: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }
            },
            rules: {
                'file.fname': [
                    {required: true, message: '请选择文件上传', trigger: 'change'}
                ]
            },
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.$refs.ruleForm.clearValidate()
            this.item = {
                filename: '',
                file: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }
            }
            this.dialogVisible = false
        },
        openDialog() {
            this.dialogVisible = true
        },
        setFile(file) {
            this.item.file = file
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                   this.$emit('submitFile', this.item)
                    this.cancel()
                }
            })
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UploadFile
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.uploadFileDialog {
    .el-dialog .el-button{
        margin-bottom: 0;
    }
    .dataTips{
        color: #C0C4CC;
        line-height: 25px
    }
}
</style>
